import { CustomTextField } from '@/components/Formik/CustomTextField';
import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Typography,
} from '@mui/material';
import { useFormikContext } from 'formik';
import { InstitutionalPageData } from './View';
interface ICompanyNameProps {
  onAdvancedStep: () => void;
}

const CompanyName = ({ onAdvancedStep }: ICompanyNameProps) => {
  const { errors } = useFormikContext<InstitutionalPageData>();

  function handleAdvanceStep() {
    if (errors.display_name || errors.slogan) return;
    onAdvancedStep();
  }

  return (
    <>
      <Typography
        variant="h6"
        sx={{
          mb: '4px',
          textAlign: 'left',
        }}
      >
        Qual o nome da sua empresa?
      </Typography>
      <Typography
        variant="body2"
        sx={{
          textAlign: 'left',
          mb: 2,
        }}
      >
        Informe o nome da sua empresa abaixo. Pode ser o nome fantasia.
      </Typography>

      <CustomTextField
        fullWidth
        variant="standard"
        name="display_name"
        placeholder="Nome da empresa"
        label="Nome da empresa"
      />

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          sx={{ width: 'fit-content', padding: 0 }}
        >
          <Typography
            variant="caption"
            sx={{ color: 'text.secondary', mr: '5px' }}
          >
            Também possuo um slogan
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: 0 }}>
          <CustomTextField
            fullWidth
            variant="standard"
            name="slogan"
            placeholder="Slogan (opcional)"
            label="Slogan (opcional)"
          />
        </AccordionDetails>
      </Accordion>

      <Button
        variant="contained"
        className="submitButton"
        onClick={handleAdvanceStep}
        fullWidth
      >
        Próximo
      </Button>
    </>
  );
};

export default CompanyName;
export type { ICompanyNameProps };
